import type { FrameKey } from "../services/promptFramesService";

export const FRAME_SLOTS: Record<FrameKey, string[]> = {
  root: ["scenarioFrame", "personaFrame", "documentFrame", "rulesFrame"],
  scenario: ["contextPrompt"],
  persona: [
    "personaName",
    "personaRole",
    "personaInstructions",
    "sessionState",
    "otherPersonaMessages",
  ],
  document: ["documentInventory", "relevantExcerpts"],
  rules: [],
};

const SLOT_PATTERN = /\{\{(\w+)\}\}/g;

export function extractSlots(content: string): string[] {
  const found = new Set<string>();
  for (const match of content.matchAll(SLOT_PATTERN)) {
    found.add(match[1]);
  }
  return [...found];
}

/** Required slots for `key` that are absent from `content`. Empty == valid. */
export function findMissingSlots(key: FrameKey, content: string): string[] {
  const present = extractSlots(content);
  return FRAME_SLOTS[key].filter((slot) => !present.includes(slot));
}
